module.exports = __webpack_public_path__ + "img/5-1_07.76fd2f5e.jpg";